<template>
  <div class="medalTop3_themeItem" v-if="datas && datas.data.dataList">
    <span
      class="medalTop_item"
      :class="
        datas.data.dataList && datas.data.dataList.length > 0
          ? `itemLen_${datas.data.dataList.length}`
          : ''
      "
      v-for="item in datas.data.dataList"
      :key="item.competitorCode"
    >
      <span class="medal_icon" :class="item.medalType"></span>
      <span
        class="medal_players"
        v-if="
          item.athleteInfos &&
          item.athleteInfos.length > 0 &&
          item.athleteInfos.length <= 2
        "
      >
        <span
          class="playerName"
          v-for="player in item.athleteInfos"
          :key="player.athleteCode"
          v-text="player.athleteName"
        ></span>
      </span>
      <span class="medal_delegation">
        <span class="delegation_logo">
          <img :src="item.organisationLogo" />
        </span>
        <span class="delegation_name" v-text="item.organisationName"></span>
      </span>
    </span>
  </div>
</template>

<script>
// 前三奖牌获得者 主题 从小项中的奖牌榜中分享而来
export default {
  name: 'medalTop3_themeItem',
  data() {
    return {
      //   players: [
      //     {
      //       seasonCode: null,
      //       eventCode: null,
      //       eventType: null,
      //       athleteCode: '2019379',
      //       gender: null,
      //       organisationCode: null,
      //       organisationName: null,
      //       organisationLogo: null,
      //       athleteName: 'CUI Yongxi',
      //       athleteNameEn: 'CUI Yongxi',
      //       athleteLogo: null,
      //       disciplineName: null,
      //     },
      //     {
      //       seasonCode: null,
      //       eventCode: null,
      //       eventType: null,
      //       athleteCode: '2019353',
      //       gender: null,
      //       organisationCode: null,
      //       organisationName: null,
      //       organisationLogo: null,
      //       athleteName: 'ZENG Fanbo',
      //       athleteNameEn: 'ZENG Fanbo',
      //       athleteLogo: null,
      //       disciplineName: null,
      //     },
      //   ],
    }
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
}
</script>

<style lang="scss" scoped>
.medalTop3_themeItem {
  width: 100%;
  padding: 0 2%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  .medalTop_item {
    /* width: 33%; */
    height: auto;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    color: var(--mixtmt_greyColor2);
    flex: 1;
    &.itemLen_1 {
      width: 100%;
    }
    &.itemLen_2 {
      width: 50%;
    }
    &.itemLen_3 {
      width: 33%;
    }
    &.itemLen_4 {
      width: 25%;
    }
    &.itemLen_5 {
      width: 20%;
    }
    .medal_icon.ME_GOLD {
      background-image: var(--mixtmt_medal_gold_icon);
    }
    .medal_icon.ME_SILVER {
      background-image: var(--mixtmt_medal_silver_icon);
    }
    .medal_icon.ME_BRONZE {
      background-image: var(--mixtmt_medal_bronze_icon);
    }
    .medal_icon {
      margin-bottom: 1.11vw;
      width: 4.16vw;
      height: 4.16vw;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      background-position: center;
      overflow: hidden;
    }
    .medal_players {
      width: 100%;
      height: auto;
      padding: 0 1.11vw;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      .playerName {
        width: 100%;
        font-size: 1.11vw;
        font-weight: bold;
        text-align: center;
        line-height: 2.083vw;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
    .medal_delegation {
      margin-top: 1.11vw;
      width: 100%;
      height: auto;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .delegation_logo {
        width: 2.083vw;
        height: 1.388vw;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .delegation_name {
        padding-left: 0.347vw;
        line-height: 1.388vw;
        font-size: 1.11vw;
      }
    }
  }
}
</style>
